import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { Session } from 'types/Session';
import { SessionQuestionnaire } from 'types/SessionQuestionnaire';
import { useParams } from 'react-router-dom';
import { RouterUrlParams } from 'App';
import MentorEvaluationModule from '../components/MentorEvaluationModule';
import { LinkDoc } from '../components/LinkDoc';

type EvaluationMentorSubpageProps = {
	session: Session;
	questionnairesData?: SessionQuestionnaire[];
	refetchQuestionnaires?: any;
};

export const EvaluationMentorSubpage = ({
	session,
	questionnairesData,
	refetchQuestionnaires,
}: EvaluationMentorSubpageProps) => {
	const { t } = useTranslation();
	const { organizationName, programName, type, pairId } = useParams() as RouterUrlParams;

	return (
		<>
			<h2 className="my-5">{t(`userPanel.sessionsNew.evaluationSurvey.mentor.heading`)}</h2>
			<p>
				<Trans
					t={t}
					i18nKey="userPanel.sessionsNew.evaluationSurvey.mentor.desc"
					components={[
						<LinkDoc
							to={`/panel/${organizationName}/${programName}/${type}/pair/${pairId}/process-summary`}
							target="_blank"
						/>,
					]}
				/>
			</p>
			<MentorEvaluationModule
				pairId={session.pairId}
				sessionType={session.sessionType}
				questionnairesData={questionnairesData}
				refetchQuestionnaires={refetchQuestionnaires}
			/>
		</>
	);
};
